export const mbUniversity = {
  trainingLocations: {
    dateFormat: 'EEEE , MMMM dd, yyyy',
    dateEndings: '{"=1":"st","=2":"nd","=3":"rd","=21":"st","=22":"nd","=23":"rd","=31":"st","other":"th"}',
    headLine: 'Training locations and dates'
  },
  trainingDescription: {
    title: 'About the training'
  },
  trainingObjectives: {
    title: 'Learning objectives',
    handsOn: {
      item: {
        image: 'miltenyi-university-objective.jpeg',
      }
    },
    onlineCourse: {
      item: {
        image: 'miltenyi-university-objective.jpeg',
      }
    }
  },

  trainingRegistration: {
    registerButton: 'Register now'
  },

  trainingUsp: {
    headline: 'Your Miltenyi University benefits',
    handsOn: {
      item1: {
        image: 'standard_applications.svg',
        description: 'Become an expert in standard and innovative applications.'
      },
      item2: {
        image: 'personalized_training.svg',
        description: 'Enjoy personalized training for individual development.'
      },
      item3: {
        image: 'skill_set.svg',
        description: 'Acquire broad expertise and a comprehensive skill set.'
      }
    },
    liveWebinar: {
      item1: {
        image: 'online_courses.svg',
        description: 'Access online courses anytime, anywhere.'
      },
      item2: {
        image: 'event.svg',
        description: 'Become an expert in standard and innovative applications.'
      },
      item3: {
        image: 'in_depth_knowledge.svg',
        description: 'Acquire broad expertise and a comprehensive skill set.'
      }
    }
  },
  trainingItem: {
    watchNowButton: 'Watch now',
    detailsButton: 'More details',
    date: 'Date:',
    length: 'Length: {{duration}} min',
    modalCaption: 'Miltenyi  University: {{caption}}'
  },
  trainingCategories: {
    titleSuffix: '<br>training courses',
    other: 'Other'
  },
  trainingList: {
    handsOn: 'Hands on training',
    liveWebinar: 'Live webinar',
    onDemandLearning: 'On demand learning',
    noResults: ' Sorry, currently no results match your search. <br />Looking for a specific training? Send us a request!'
  }
}
